import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HelpOutline, ArrowBack, ExpandMore, ExpandLess } from '@mui/icons-material';

const faqItems = [
    {
        question: 'Comment me connecter à Netikash Flow ?',
        answer: 'Utilisez vos identifiants (email ou téléphone et mot de passe) sur la page de connexion. Après authentification, choisissez l\'organisation avec laquelle vous souhaitez travailler, puis votre rôle (Admin ou Caissier) si vous avez plusieurs rôles.'
    },
    {
        question: 'Comment créer une demande de paiement ?',
        answer: 'Depuis la section Demandes de paiement (Admin ou Caissier), cliquez sur « Nouvelle demande », sélectionnez le terminal, le montant, la devise, le réseau (Mobile Money, etc.) et le numéro du client. La demande est envoyée au client qui peut payer depuis son téléphone.'
    },
    {
        question: 'Comment envoyer un lien de paiement ?',
        answer: 'Dans Liens de paiement, créez un nouveau lien en renseignant le titre, le montant, la devise, le client (ou laissez le champ pour paiement libre) et le terminal. Vous pouvez partager le lien par SMS, email ou WhatsApp selon la méthode choisie.'
    },
    {
        question: 'Où voir mes factures et les modifier ?',
        answer: 'Les factures sont accessibles dans la section Facturation / Invoicing. Vous pouvez consulter, éditer (si l\'API le permet), ajouter des notes et gérer la normalisation DGI depuis le détail de chaque facture.'
    },
    {
        question: 'Comment changer d\'organisation ?',
        answer: 'En haut à droite, cliquez sur le nom de l\'organisation actuelle ou sur « Mes Organisations » dans la barre latérale. Sélectionnez l\'autre compte dans la liste puis validez. La page se recharge avec les données de la nouvelle organisation.'
    }
];

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-amber-50/30">
            <div className="max-w-3xl mx-auto px-6 py-12">
                <Link
                    to="/"
                    className="inline-flex items-center space-x-2 text-amber-600 hover:text-amber-700 font-medium mb-8"
                >
                    <ArrowBack className="text-lg" />
                    <span>Retour à l'accueil</span>
                </Link>
                <div className="flex items-center space-x-4 mb-8">
                    <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl flex items-center justify-center shadow-lg">
                        <HelpOutline className="text-white text-2xl" />
                    </div>
                    <div>
                        <h1 className="text-3xl font-bold text-slate-900">FAQ</h1>
                        <p className="text-slate-600">Questions fréquentes – Netikash Flow</p>
                    </div>
                </div>
                <div className="space-y-3">
                    {faqItems.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden"
                        >
                            <button
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                className="w-full flex items-center justify-between p-4 text-left hover:bg-slate-50/50 transition-colors"
                            >
                                <span className="font-semibold text-slate-900 pr-4">{item.question}</span>
                                {openIndex === index ? (
                                    <ExpandLess className="text-amber-600 flex-shrink-0" />
                                ) : (
                                    <ExpandMore className="text-amber-600 flex-shrink-0" />
                                )}
                            </button>
                            {openIndex === index && (
                                <div className="px-4 pb-4 pt-0">
                                    <p className="text-slate-600 leading-relaxed">{item.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQ;
